import _ from "underscore";

import api from "@/helpers/api";
import auth from "@/helpers/auth";

const apiVersion = 'v1';
const source = 'wrongcfgevents';

export default {
  state: {
    all: [],
    current: null,
    meta: [],
    currentPage: 1,
    per_page: 10
  },
  mutations: {
    SetWrongCfgEvents(state,{list, metadata}) {
      state.all = list;
      state.meta.currentpage = metadata['current-page'];
      state.meta.nextpage = metadata['next-page'];
      state.meta.prevpage = metadata['prev-page'];
      state.meta.totalpages = metadata['total-pages'];
      state.meta.totalcount = metadata['total-count'];
    },
    setCfgCurrentPage(state,val) {
      state.currentPage = val;
    },
    setCfgPageSize(state,val) {
      state.per_page = val;
      state.currentPage = 1;
    }
  },
  actions: {
    fetchWrongCfgEvents({ commit, state }, callback = null)  {
      const params = {
        team_id: auth.teamId(),
        sort_by: "created_at",
        sort_order: "desc",
        per_page: state.per_page,
        page: state.currentPage
      };

      return api
        .instance()
        .get(`${apiVersion}/${source}`, {params})
        .then((resp) => {
          const list = _.map(resp.data.data, (cat) => cat.attributes);
          const metadata = resp.data.meta;
          commit("SetWrongCfgEvents", { list, metadata } );
        })
        .catch((err) => console.error("Failed to fetch wrong cfgs", err));
    }
  }
};
